import { getOppositionProgress } from "api/opposition";

const WORKFLOW_STEP_TO_PATH: Record<
  string,
  { section: "discussion" | "filing" | "status"; slug: string }
> = {
  OP_S1_01_PRELIMINARY_DISCUSSION: {
    section: "discussion",
    slug: "preliminary-discussion-with-the-client",
  },
  OP_S1_02_APPLICATION_DETAILS_FROM_CLIENT: {
    section: "discussion",
    slug: "application-details-from-client",
  },
  OP_S1_03_STATUS_DETAILS: {
    section: "discussion",
    slug: "status-details",
  },
  OP_S1_04_NOTICE_TO_CLIENT: {
    section: "discussion",
    slug: "notice-to-client",
  },
  OP_S1_05_INFORM_CLIENT: {
    section: "discussion",
    slug: "inform-client",
  },
  OP_S1_06_CALL_CLIENT_FOR_OPPOSITION: {
    section: "discussion",
    slug: "call-client-for-opposition",
  },
  OP_S1_07_CLIENT_CONFIRMATION: {
    section: "discussion",
    slug: "client-confirmation",
  },
  OP_S1_08_INVOICE_TO_CLIENT: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  OP_S1_08A_INVOICE_SAVED: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  OP_S1_08B_INVOICE_GENERATED: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  OP_S1_08C_INVOICE_SENT_TO_CLIENT: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  OP_S1_08D_INVOICE_PAYMENT_MESSAGE_SENT: {
    section: "discussion",
    slug: "invoice-to-client",
  },
  OP_S1_09_PAYMENT_FROM_CLIENT: {
    section: "discussion",
    slug: "payment-from-client",
  },
  OP_S2_01_PREPARE_OPPOSITION: {
    section: "filing",
    slug: "prepare-opposition",
  },
  OP_S2_02_FILE_OPPOSITION: {
    section: "filing",
    slug: "file-opposition",
  },
  OP_S2_03_INFORM_CLIENT_OF_FILING: {
    section: "filing",
    slug: "inform-client-of-filing",
  },
  OP_S2_04_NOTICE_OF_OPPOSITION_BY_REGISTRY: {
    section: "filing",
    slug: "notice-of-opposition-by-registry",
  },
  OP_S2_05_INFORM_CLIENT_OF_NOTICE_OF_OPPOSITION: {
    section: "filing",
    slug: "inform-client-of-notice-of-opposition",
  },
};

const DEFAULT_STEP = {
  section: "discussion" as const,
  slug: "preliminary-discussion-with-the-client",
};

/**
 * Resolves the in-app path for an opposition lead's most recently completed
 * workflow step so the user lands directly on it from pending items.
 *
 * Falls back to the preliminary discussion step when the lead has no completed
 * steps yet, when the step has no implemented UI route, or when progress fails.
 */
export async function getOppositionPathForLead(leadId: string): Promise<string> {
  try {
    const progress = await getOppositionProgress(leadId);
    const lastCompleted = [...progress.steps]
      .reverse()
      .find((s) => s.isCompleted)?.slug;
    const stepKey =
      lastCompleted ?? progress.maxStepReached ?? progress.currentStep ?? null;
    const pathSpec = stepKey ? WORKFLOW_STEP_TO_PATH[stepKey] : null;
    const { section, slug } = pathSpec ?? DEFAULT_STEP;
    return `/dashboard/opposition/new/${section}/${slug}/${leadId}`;
  } catch {
    return `/dashboard/opposition/new/discussion/preliminary-discussion-with-the-client/${leadId}`;
  }
}
